<template>
    <Drawer
        width="300"
        placement="right"
        :closable="false"
        :visible="visible"
        v-bind="$attrs"
        @close="close"
    >
        <div
            slot="title"
            class="flex items-center justify-between"
        >
            {{ $t('pricing') }}
            <AntButton
                type="primary"
                @click="save"
            >
                {{ $t('save') }}
            </AntButton>
        </div>
        <NumberFieldWithValidation
            v-model="cost"
            name="cost"
            :formatter="$formatMoney"
            :parser="moneyParser"
            :label="$t('costForSupplier')"
        />
        <NumberFieldWithValidation
            v-model="price"
            name="price"
            :formatter="$formatMoney"
            :parser="moneyParser"
            :label="$t('price')"
        />
        <i v-text="$t('theTotalCostWillBe', {'cost': formattedTotalPrice})" />
    </Drawer>
</template>

<script>
import NumberFieldWithValidation from '@/components/forms/elements/withValidation/NumberFieldWithValidation.vue';
import { Button } from 'ant-design-vue';
import drawerMixin from '@/mixins/drawerMixin';
import { mapActions } from 'vuex';
export default {
    name: 'MeasurePricingDrawer',
    components: {
        AntButton: Button,
        NumberFieldWithValidation,
    },
    mixins: [drawerMixin],
    props: {
        measure: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        cost: null,
        price: null,
    }),
    computed: {
        formattedTotalPrice() {
            return this.$formatMoney(this.cost + this.price);
        },
    },
    watch: {
        measure: {
            immediate: true,
            deep: true,
            handler() {
                const { cost, price } = this.measure;

                this.cost = cost
                    ? parseInt(cost, 10)
                    : null;

                this.price = price
                    ? parseInt(price, 10)
                    : null;
            },
        },
    },
    methods: {
        ...mapActions({
            updatePricing: 'measures/updatePricing',
        }),
        moneyParser(value) {
            if (value === null) {
                return value;
            }

            return parseInt(value.replace(/[$€,.]/g, ''), 10);
        },
        async save() {
            this.close();

            const { cost, price } = this;

            await this.updatePricing({ cost, price });

            this.$notification.success({
                message: this.$t('entitySaved', {
                    entity: this.$t('pricing'),
                }),
            });
        },
    },

};
</script>

<style>

</style>